import { useId } from "react";
import { InputText } from "primereact/inputtext";
import { AutoComplete } from "primereact/autocomplete";
import { Message } from 'primereact/message';

export function NewRouteForm({values, onChangeRouteId, onChangeRouteShortName, onChangeRouteLongName}) {
  formId = useId();
  return (
    <>
      <div className="field grid">
        <label for={formId + '_route_id'} className="col-fixed" style={{width: '40%'}}>ID nowej linii</label>
        <div className="col w-auto">
          <InputText 
            id={formId + '_route_id'} 
            value={values.route_id} 
            style="w-100" 
            onChange={onChangeRouteId} 
            invalid={Boolean(values.validation_errors.route_id)}
          />
          {
            (values.validation_errors.route_id) 
            ?
              <Message severity="error" className='mt-1' text={values.validation_errors.route_id} />
            :
              <></>
          }
        </div>
      </div>
      <div className="field grid">
        <label for={formId + '_route_short_name'} className="col-fixed" style={{width: '40%'}}>Numer nowej linii</label>
        <div className="col w-auto">
          <InputText 
            id={formId + '_route_short_name'} 
            value={values.route_short_name} 
            style="w-100" 
            onChange={onChangeRouteShortName} 
            invalid={Boolean(values.validation_errors.route_short_name)}
          />
          {
            (values.validation_errors.route_short_name) 
            ?
              <Message severity="error" className='mt-1' text={values.validation_errors.route_short_name} />
            :
              <></>
          }
        </div>
      </div>
      <div className="field">
        <label for={formId + '_route_name'}>Pełna nazwa nowej linii</label>
        <AutoComplete 
          className="w-full" 
          inputClassName="w-full" 
          value={values.route_long_name} 
          id={formId + '_route_name'} 
          onChange={onChangeRouteLongName}
          invalid={Boolean(values.validation_errors.route_long_name)}
        >
        </AutoComplete>
        {
            (values.validation_errors.route_long_name) 
            ?
              <Message severity="error" className='mt-1' text={values.validation_errors.route_long_name} />
            :
              <></>
        }
      </div>
    </>
  );
}




